import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import OverflowTooltip from '@adsk/bim360-matrix-react-overflow-tooltip';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import isContentOverflowingElement from '@adsk/bim360-matrix-react-helpers/es/isContentOverflowingElement';
/**
 * TableCell for the Table
 */
class TableCell extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isHovered: false
    };

    this._setContainerRef = this._setContainerRef.bind(this);
    this._handleMouseEnter = this._handleMouseEnter.bind(this);
    this._handleMouseLeave = this._handleMouseLeave.bind(this);
  }

  render() {
    const { className, style, tooltip, children, container, tooltipPopoverProps } = this.props;
    const { isHovered } = this.state;

    if (!children) return null;

    const isTruncated = isContentOverflowingElement(this.container);
    const controlledTooltipShow =
      tooltipPopoverProps && 'show' in tooltipPopoverProps ? tooltipPopoverProps.show : !!tooltip;
    const showTooltip = isHovered && (controlledTooltipShow || isTruncated);
    const tooltipClassName = classnames(
      'BaseTable__cell-popover',
      tooltipPopoverProps && tooltipPopoverProps.tooltipClassName
    );

    return (
      <div
        ref={this._setContainerRef}
        className={className}
        style={style}
        onMouseEnter={this._handleMouseEnter}
        onMouseLeave={this._handleMouseLeave}
      >
        {showTooltip ? (
          <OverflowTooltip
            place={Tooltip.Places.TOP}
            {...tooltipPopoverProps}
            tooltipClassName={tooltipClassName}
            show
            className="BaseTable__cell"
            content={tooltip || children}
            container={container}
          >
            {children}
          </OverflowTooltip>
        ) : (
          children
        )}
      </div>
    );
  }

  _setContainerRef(ref) {
    this.container = ref;
  }

  _handleMouseEnter() {
    this.setState({
      isHovered: true
    });
  }

  _handleMouseLeave() {
    this.setState({
      isHovered: false
    });
  }
}

TableCell.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  tooltip: PropTypes.node,
  children: PropTypes.string,
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  tooltipPopoverProps: PropTypes.shape({
    show: PropTypes.bool,
    tooltipClassName: PropTypes.string
  })
};

export default TableCell;
